export const CONTACT = {
  phone: "929-498-0793",
  phoneHref: "tel:+19294980793",
  email: "perfectcleanersny@gmail.com",
  emailHref: "mailto:perfectcleanersny@gmail.com",
};

export const SOCIALS = [
  { name: "Instagram", handle: "@perfecttouchlogistics", icon: "instagram", url: "https://instagram.com/perfecttouchlogistics" },
  { name: "Facebook", handle: "Perfect Touch Detailed Cleaning & Logistics", icon: "facebook", url: "https://www.facebook.com/share/18yrMjcKw9/?mibextid=wwXIfr" },
  { name: "TikTok", handle: "@perfecttouchny", icon: "tiktok", url: "https://www.tiktok.com/@perfecttouchny" },
  { name: "YouTube", handle: "@perfecttouchlogistics", icon: "youtube", url: "https://www.youtube.com/@perfecttouchlogistics" },
];

export const RESIDENTIAL_SERVICES = [
  {
    title: "Standard Cleaning",
    price: "$120",
    priceLabel: "Starting at",
    desc: "Routine cleaning for homes and apartments.",
    image: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: "Residential",
  },
  {
    title: "Deep Cleaning",
    price: "$180",
    priceLabel: "Starting at",
    desc: "Detailed cleaning for homes requiring additional attention.",
    image: "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: "Most Detailed",
  },
  {
    title: "Move-In / Move-Out",
    price: "$200",
    priceLabel: "Starting at",
    desc: "Detailed cleaning for customers preparing to move into or leave a property.",
    image: "https://images.unsplash.com/photo-1576698483491-8c43f0862543?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: "Transitions",
  },
  {
    title: "Recurring Cleaning",
    price: "Weekly • Biweekly • Monthly",
    priceLabel: "Flexible plans",
    desc: "Keep your space consistently cared for on a schedule that fits your life.",
    image: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: "Subscription",
  },
  {
    title: "Airbnb / Short-Term Turnover",
    price: "$100",
    priceLabel: "Starting at",
    desc: "Fast, reliable turnover cleaning between short-term rental guests.",
    image: "https://images.pexels.com/photos/8135492/pexels-photo-8135492.jpeg?auto=compress&cs=tinysrgb&w=1200",
    tag: "Hosts",
  },
];

export const RESIDENTIAL_TABS = [
  {
    key: "standard",
    name: "Standard Cleaning",
    price: "$105",
    priceLabel: "Starting at",
    headline: "Consistent, Everyday Freshness",
    body: "Routine cleaning that keeps your home consistently fresh, comfortable and well-maintained. Ideal for regular upkeep between deeper cleans, so your space always feels cared for.",
    tagline: "Come home to a cleaner, healthier, more inviting space.",
    cta: "Request Your Personalized Estimate",
    image: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "deep",
    name: "Deep Cleaning",
    price: "$165",
    priceLabel: "Starting at",
    headline: "A Deeper Clean. A Noticeable Difference.",
    body: "When your home needs more than routine maintenance, our Deep Cleaning provides the detailed attention your space deserves. We focus on the areas often overlooked during regular cleaning, working carefully through built-up dirt, dust, grime and hard-to-reach spaces. Ideal for first-time clients, seasonal refreshes, special occasions, or homes that simply need a thorough reset.",
    tagline: "More detail. More care. A truly refreshed home.",
    cta: "Request a Deep Cleaning Estimate",
    image: "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "move",
    name: "Move-In / Move-Out",
    price: "$195",
    priceLabel: "Starting at",
    headline: "A Spotless Start or a Clean Goodbye",
    body: "Detailed cleaning for customers preparing to move into or leave a property—leaving the space spotless and move-in ready, or fully refreshed as you move out. We handle the deep detail so the transition is one less thing to worry about.",
    tagline: "Move with confidence, on a clean slate.",
    cta: "Request a Move Cleaning Estimate",
    image: "https://images.unsplash.com/photo-1576698483491-8c43f0862543?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "recurring",
    name: "Recurring Cleaning",
    price: "Weekly • Biweekly • Monthly",
    priceLabel: "Preferred pricing",
    headline: "Consistent Care. Preferred Pricing.",
    body: "Keep your home looking its best with a recurring plan designed around your schedule and lifestyle. As a valued recurring client, you benefit from preferred pricing based on your service frequency—the more consistently you schedule, the more favorable your recurring rate compared with one-time appointments.",
    discounts: [
      { label: "Weekly", value: "15% off" },
      { label: "Biweekly", value: "10% off" },
      { label: "Monthly", value: "5% off" },
    ],
    tagline: "Stay clean. Stay consistent. Enjoy preferred recurring rates.",
    cta: "Request Your Recurring Cleaning Quote",
    image: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "airbnb",
    name: "Airbnb / Short-Term",
    price: "$100",
    priceLabel: "Starting at",
    headline: "Turn Every Guest Stay Into a Five-Star Experience",
    body: "Our Airbnb and short-term rental cleaning gets your property guest-ready, spotless and presentation-perfect between stays. We focus on the details guests notice—sparkling bathrooms, fresh linens, spotless kitchens, polished surfaces and a welcoming overall appearance.",
    tagline: "You manage the booking. We prepare the experience.",
    cta: "Schedule Your Turnover Cleaning",
    image: "https://images.pexels.com/photos/8135492/pexels-photo-8135492.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];

export const ADDONS = [
  { name: "Inside Oven", price: "$35" },
  { name: "Inside Refrigerator", price: "$35" },
  { name: "Interior Windows", price: "$5/item" },
  { name: "Inside Cabinets", price: "$30" },
  { name: "Baseboards", price: "$30" },
  { name: "Laundry Wash/Dry/Fold", price: "$40/load" },
  { name: "Ironing", price: "$3–$5/item" },
  { name: "Bed Linen Change", price: "$15/bed" },
  { name: "Interior Doors", price: "$10/door" },
  { name: "Wall Spot Cleaning", price: "$40+" },
  { name: "Pet-Hair Removal", price: "$40+" },
  { name: "Organization", price: "$50/hour" },
];

export const COMMERCIAL_SERVICES = [
  "Office cleaning",
  "Retail cleaning",
  "Restroom cleaning",
  "Break-room cleaning",
  "Common-area cleaning",
  "Recurring commercial maintenance",
  "Commercial deep cleaning",
  "Professional establishments",
];

export const LOGISTICS_SERVICES = [
  "Local pickup and delivery",
  "Small-item delivery",
  "Residential delivery assistance",
  "Business-to-customer delivery",
  "Supply pickup",
  "Restocking",
  "Local transportation coordination",
  "Other eligible logistics requests",
];

export const LOGISTICS_FACTORS = [
  "Distance", "Number of stops", "Time", "Item size", "Item weight",
  "Labor", "Parking", "Tolls", "Waiting time", "Special handling",
  "Urgency", "Vehicle requirements",
];

export const WHY_CARDS = [
  { n: "01", icon: "sparkles", title: "Detailed Service", text: "We focus on the details that make your space feel refreshed and cared for." },
  { n: "02", icon: "home", title: "Personalized Cleaning", text: "Every property is different. We tailor our service to your specific needs." },
  { n: "03", icon: "message-circle", title: "Professional Communication", text: "Clear communication from your first request through service completion." },
  { n: "04", icon: "wallet", title: "Transparent Estimates", text: "Know your agreed service scope and price before your appointment is confirmed." },
  { n: "05", icon: "calendar", title: "Flexible Scheduling", text: "Convenient online requests and booking are available 24/7." },
  { n: "06", icon: "heart", title: "Customer-Focused", text: "Your home, property, time and experience matter to us. Your satisfaction is our priority." },
];

export const SURFACES = [
  "Quartz", "Porcelain", "LVP", "Laminate", "Stainless Steel", "Natural Stone",
  "Hardwood", "Acrylic", "Ceramic", "Glass", "Mirror", "Granite", "Marble",
  "Travertine", "Brass", "Electronics", "Upholstery", "Leather", "Painted Wood", "Fiberglass",
];

export const SERVICE_AREAS = ["Queens", "Brooklyn", "Manhattan", "Long Island", "Nassau County"];

export const FAQS = [
  { q: "How much does cleaning cost?", a: "Cleaning prices are based on several factors, including the size of the property, number of rooms and bathrooms, condition of the space, type of cleaning requested, frequency of service, and any additional services selected.\n\nBecause every property has different cleaning requirements, we provide a personalized quote based on the specific scope of work. Pricing is confirmed before the service is scheduled.\n\nFor recurring cleaning, preferred rates may be available based on the frequency of service, including weekly, biweekly, or monthly cleaning." },
  { q: "Do you offer recurring cleaning?", a: "Yes. We offer flexible recurring cleaning services for both residential and eligible commercial clients.\n\nAvailable schedules may include weekly, biweekly, and monthly service, depending on your needs and the type of property.\n\nRecurring service pricing is based on the selected frequency and scope of work. More frequent cleaning may qualify for a preferred recurring rate because the property is maintained more consistently.\n\nAs a general guide, recurring residential clients enjoy preferred savings on the standard rate: 15% off weekly, 10% off biweekly, and 5% off monthly service." },
  { q: "Do you offer commercial cleaning?", a: "Yes. We provide commercial cleaning services for businesses and commercial properties based on their specific cleaning requirements.\n\nCommercial services may include routine cleaning, scheduled maintenance, and other agreed-upon cleaning services. Pricing is determined by factors such as the size and type of facility, frequency of service, number of areas requiring cleaning, condition of the property, and scope of work.\n\nA consultation or property assessment may be required before a commercial service agreement or recurring schedule is established." },
  { q: "Do you offer logistics services?", a: "Yes. Perfect Touch also provides logistics services and related support based on the specific needs of each client.\n\nBecause logistics requirements can vary significantly, pricing and availability depend on the type of service, location, timing, size, and scope of the request.\n\nPlease contact us with the details of your logistics needs so we can determine the appropriate service and provide a personalized quote." },
  { q: "Do I have to be home during the cleaning?", a: "No. You do not have to be present during your scheduled cleaning service.\n\nIf you will not be home or present at the property, you must provide safe and authorized access before the appointment, such as a key, access code, concierge/building access, or another mutually agreed arrangement.\n\nFor security and liability purposes, Perfect Touch will only enter a property with proper authorization from the client or an authorized representative." },
  { q: "Can I add Perfect Touch to my phone?", a: "Yes. You can add the Perfect Touch website to your phone's home screen for convenient access.\n\nThis allows you to quickly return to our website to request a quote, review our services, contact us, or access other available features without having to search for our website each time." },
  { q: "Do you bring cleaning supplies?", a: "Yes. We provide the standard cleaning supplies, tools, and equipment needed to perform the services included in your scheduled cleaning appointment.\n\nIf you have specific product preferences, allergies, sensitivities, delicate surfaces, or special cleaning requirements, please inform us before the appointment.\n\nSpecialty products, specialized equipment, or services requiring materials outside our standard cleaning supplies may require an additional charge. Any applicable additional cost will be communicated before the additional service is performed." },
  { q: "How do I pay?", a: "Payment is made electronically using the payment methods available through Perfect Touch at the time of booking, invoicing, or service completion.\n\nAny required deposit, booking fee, payment deadline, or remaining balance will be clearly communicated before your service is confirmed.\n\nThe final amount is based on the approved quote and agreed-upon scope of work.\n\nIf you request additional services or work beyond the original scope, the additional cost will be communicated and approved before it is added to your final balance." },
];

export const TESTIMONIALS = [
  { name: "Danielle R.", area: "Astoria, Queens", text: "Immaculate work and genuinely professional from the first message to the final walkthrough. My apartment has never looked better." },
  { name: "Marcus T.", area: "Park Slope, Brooklyn", text: "Booked a deep clean before guests arrived. The attention to detail on the baseboards and kitchen was unreal. Worth every dollar." },
  { name: "Priya S.", area: "Upper East Side, Manhattan", text: "I use their recurring biweekly service. Reliable, consistent, and the communication is always clear. Highly recommend." },
];

// Grouped service-detail options shown in the quote form, keyed by service type.
export const SERVICE_DETAIL_OPTIONS = {
  residential: [
    {
      group: "Standard Cleaning",
      items: ["Studio", "1 Bed / 1 Bath", "2 Bed / 1 Bath", "2 Bed / 2 Bath",
        "3 Bed / 1-2 Bath", "3 Bed / 2.5+ Bath", "4 Bed / 2 Bath", "4 Bed / 3+ Bath", "5+ Bedroom"],
    },
    { group: "Deep Cleaning", items: ["Studio", "1 Bedroom", "2 Bedroom", "3 Bedroom", "4 Bedroom", "5+ Bedroom"] },
    { group: "Move-In / Move-Out", items: ["Studio", "1 Bedroom", "2 Bedroom", "3 Bedroom", "4 Bedroom", "5+ Bedroom"] },
    {
      group: "Airbnb / Short-Term Turnover",
      items: ["Studio", "1 BR / 1 Bath", "2 BR / 1 Bath", "2 BR / 2 Bath",
        "3 BR / 2 Bath", "3 BR / 3 Bath", "4 BR / 2-3 Bath", "5+ BR"],
    },
  ],
  commercial: [
    {
      group: "Space Type & Size",
      items: ["Small office", "1,000 sq. ft. office", "2,000 sq. ft. office", "3,000 sq. ft. office",
        "5,000 sq. ft. office", "10,000 sq. ft. office", "Retail space", "Medical / clinical",
        "Warehouse", "Larger / multi-site"],
    },
  ],
  logistics: [
    {
      group: "Logistics Service",
      items: ["Local pickup and delivery", "Small-item delivery", "Residential delivery assistance",
        "Business-to-customer delivery", "Supply pickup", "Restocking",
        "Local transportation coordination", "Other eligible logistics request"],
    },
  ],
};

// Commercial pricing reference (guidance only) shown when Commercial is selected.
export const COMMERCIAL_PRICING = [
  { type: "Office cleaning", rate: "$0.10–$0.20 / sq. ft." },
  { type: "High-detail office", rate: "$0.15–$0.25 / sq. ft." },
  { type: "Medical / clinical", rate: "$0.20–$0.35+ / sq. ft." },
  { type: "Retail", rate: "$0.15–$0.25 / sq. ft." },
  { type: "Warehouse", rate: "$0.05–$0.12 / sq. ft." },
  { type: "Commercial deep cleaning", rate: "$0.25–$0.50+ / sq. ft." },
];

// Client policy — REPLACE with the owner's exact previous-website policy text.
export const CLIENT_POLICY = [
  {
    title: "Estimates & Booking",
    text: "All quotes are personalized estimates based on the information you provide. Final pricing is confirmed before your appointment is booked. Prices may be adjusted for excessive condition, added scope or accessibility discovered on site.",
  },
  {
    title: "Cancellations & Rescheduling",
    text: "We kindly ask for at least 24 hours' notice to cancel or reschedule. Late cancellations or lockouts (no access on arrival) may be subject to a fee.",
  },
  {
    title: "Access & Entry",
    text: "You do not need to be home. Access arrangements (keys, codes, doorman, lockbox) can be coordinated in advance. Please secure pets and valuables before service.",
  },
  {
    title: "Payment & Deposit",
    text: "A 20% down payment deposit is required to confirm and reserve your appointment. The remaining balance is due upon completion using the electronic payment methods offered with your invoice, unless other arrangements are made in advance. Deposits hold your scheduled time and may be applied toward your service.",
  },
  {
    title: "Limitation & Liability",
    text: "Our team is insured, and our liability is limited to the value of the cleaning service provided, except where otherwise required by law or covered by applicable insurance. We treat every home and property with genuine care and professionalism. To protect what matters most to you, please secure all valuables, cash, jewelry, heirlooms, electronics and fragile or delicate items prior to your appointment. Perfect Touch is not responsible for pre-existing damage, normal wear and tear, or for any item, object or property that is not securely placed, mounted, stabilized or properly positioned, including loosely hung décor, unsecured shelving, unstable furniture and improperly installed fixtures. Any concern regarding service must be reported to us in writing within 24 hours of completion so we can review and, where verified, address it in accordance with this policy and our applicable insurance coverage. Rest assured, we are fully committed to caring for your space with detail and respect.",
  },
  {
    title: "Satisfaction",
    text: "Your satisfaction is our priority. If something isn't right, contact us within 24 hours and we'll make it right for the areas serviced.",
  },
  {
    title: "Safety & Scope",
    text: "For safety, our team cannot move heavy furniture, use unstable ladders, or handle hazardous materials, biohazards or extreme conditions. Certain requests may require a specialized quote.",
  },
];

// OUR WORK gallery — real project photographs supplied by the owner (authentic, unedited, no on-photo labels).
export const OUR_WORK = [
  { src: "/our-work/oven.webp", category: "Oven & Kitchen Deep Cleaning", caption: "Oven deep clean — baked-on grease and residue fully removed.", pair: true },
  { src: "/our-work/stovetop.jpg", category: "Oven & Kitchen Deep Cleaning", caption: "Stovetop degreased and detailed, from burners to backsplash.", pair: true },
  { src: "/our-work/bathroom-full.jpg", category: "Bathroom Cleaning", caption: "Full bathroom reset — tub, tile, vanity and floor detailed.", pair: true },
  { src: "/our-work/bathroom-tub.jpg", category: "Bathroom Cleaning", caption: "Tub, grout lines and fixtures restored to bright white.", pair: true },
  { src: "/our-work/bathroom-toilet.jpg", category: "Bathroom Cleaning", caption: "Toilet and surrounding tile sanitized and polished.", pair: true },
  { src: "/our-work/balcony.jpg", category: "Residential Cleaning", caption: "Balcony and outdoor space deep clean in progress.", pair: false },
  { src: "/our-work/pantry.webp", category: "Pantry & Cabinet Cleaning", caption: "Pantry emptied, detailed and reorganized shelf by shelf.", pair: true },
  { src: "/our-work/windows.webp", category: "Window Cleaning", caption: "Window glass, frames and sills carefully detailed.", pair: false },
  { src: "/our-work/commercial.webp", category: "Commercial Cleaning", caption: "Commercial space cleared, detailed and guest-ready.", pair: true },
  { src: "/our-work/commercial-2.jpg", category: "Commercial Cleaning", caption: "Floors, tables and seating reset and ready for opening.", pair: true },
];

// Real before/after photos (single combined image each, BEFORE|AFTER labels baked in).
export const BEFORE_AFTER = [
  { image: "/ba-bedroom.jpg", label: "Bedroom Reset", area: "Residential · Standard Clean" },
  { image: "/ba-bathtub.jpg", label: "Bathtub Restoration", area: "Bathroom · Deep Clean" },
  { image: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/byrlah69_IMG-20260821-WA0000.jpg", label: "Living Room Refresh", area: "Residential · Queens" },
  { image: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/26ccp8kn_5E7936AB-02CA-4E18-B262-7FCC138E3301.png", label: "Office & Storage Organization", area: "Commercial · Deep Clean" },
  { image: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/br34z5nq_IMG-20260821-WA0002.jpg", label: "Stovetop Deep Clean", area: "Deep Cleaning" },
  { image: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/jb3rbf18_IMG-20260821-WA0003.jpg", label: "Kitchen & Cabinet Detail", area: "Kitchen · Organization" },
  { image: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/fz0mam7j_IMG-20260821-WA0004.jpg", label: "Workspace Declutter", area: "Home Office" },
  { image: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/g0jyyah6_IMG-20260821-WA0001.jpg", label: "Office & Reception", area: "Commercial" },
  { image: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/ybt0f3l8_79780a98-71d7-479f-a28b-dcf6d1282ce2.jpeg", label: "Spotless Tile Floors", area: "Detailed Cleaning" },
  { image: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/eiedofy0_74a8d63e-f41f-45ff-b23e-8e4bdb5d3124.jpeg", label: "Refrigerator Deep Clean", area: "Inside & Out" },
  { image: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/l3ve9trg_93965700-8837-4a72-aca7-9023906ce589.jpeg", label: "Bathtub & Tile Detail", area: "Bathroom" },
  { image: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/eq4ti6gl_2a891d5b-15c8-4bbc-a229-d2843b916e76.jpeg", label: "Move-Out Ready Room", area: "Move-In / Move-Out" },
];

export const IMAGES = {
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_touch-cleaning-ny/artifacts/pmlwjh7m_IMG-20260821-WA0006.jpg",
  heroInterior: "https://images.unsplash.com/photo-1663811397219-c572550dffc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxzcG90bGVzcyUyMGx1eHVyeSUyMGxpdmluZyUyMHJvb20lMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTE1OTAwNzd8MA&ixlib=rb-4.1.0&q=85&w=1920",
  bathroom: "https://images.unsplash.com/photo-1576698483491-8c43f0862543?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cleaner: "https://images.pexels.com/photos/6195274/pexels-photo-6195274.jpeg?auto=compress&cs=tinysrgb&w=1600",
  closet: "https://images.pexels.com/photos/7587738/pexels-photo-7587738.jpeg?auto=compress&cs=tinysrgb&w=1600",
  livingRoom: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  commercial: "https://images.unsplash.com/photo-1502005097973-6a7082348e28?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  logisticsVan: "/logistics-van.jpg",
  courier: "https://static.prod-images.emergentagent.com/jobs/6e04c774-3656-4488-9fe2-e9ef0bf5b188/images/65fc157b0b69a837c044387f168341aa4473a45cc70eaf7590b01cacc5973e8f.jpeg",
  skyline: "https://images.unsplash.com/photo-1505811210036-052144988918?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
};
